import * as React from 'react'

// hooks
import useEventListener from './useEventListener'

// context
import { useStreamContext } from "../context"

declare global {
  interface Window {
    [key: string]: any
  }
}

export default function useStreamEvents() {

  const streamContext = useStreamContext()

  const player = typeof window !== 'undefined' && window.player ? window.player : null
  const stream = player?.stream

  /***
   * webRtc
   */
  useEventListener(stream, 'webRtcAutoConnect', () => {
    streamContext.setWebrtcStatus('autoConnect')
  })

  useEventListener(stream, 'webRtcConnecting', () => {
    streamContext.setWebrtcStatus('connecting')
  })

  useEventListener(stream, 'webRtcConnected', () => {
    streamContext.setWebrtcStatus('connected')
  })

  useEventListener(stream, 'webRtcFailed', () => {
    streamContext.setWebrtcStatus('failed')
  })

  useEventListener(stream, 'webRtcDisconnected',
    ({ data: { eventString, showActionOrErrorOnDisconnect } }: { data: { eventString: string, showActionOrErrorOnDisconnect: boolean } }) => {
      if (showActionOrErrorOnDisconnect == false) {
        streamContext.setWebrtcStatus('disconnected', eventString)
      } else {
        streamContext.setWebrtcStatus('disconnectedRestart', eventString)
      }
    })

  /***
   * streamer
   */

  useEventListener(stream, 'videoInitialized', () => {
    streamContext.setStreamStatus('initialized')
  })

  useEventListener(stream, 'streamLoading', () => {
    streamContext.setStreamStatus('loading')
  })

  useEventListener(stream, 'playStreamError',
    ({ data: { message } }: { data: { message: string } }) => {
      streamContext.setStreamStatus('error', message)
    })

  useEventListener(stream, 'playStream', () => {
    streamContext.setStreamStatus('play')
  })

  // useEventListener(stream?.videoElementParent, 'click', () => {
  //   if (streamContext.state.webrtcStatus == 'connected') {
  //     if (streamContext.state.streamStatus !== 'play') {
  //       streamContext.setStreamStatus('play')
  //     }
  //   }
  // })

  useEventListener(stream, 'playStreamRejected',
    ({ data: { reason } }: { data: { reason: string } }) => {
      streamContext.setStreamStatus('rejected', reason)
    })

  useEventListener(stream, 'loadFreezeFrame',
    ({ data: { shouldShowPlayOverlay } }: { data: { shouldShowPlayOverlay: boolean } }) => {
      streamContext.setFreezeFrame(shouldShowPlayOverlay)
    })


  // this.stream.addEventListener(
  //   'statsReceived',
  //   ({ data: { aggregatedStats } }) =>
  //     this.onStatsReceived(aggregatedStats)
  // );
  // this.stream.addEventListener(
  //   'latencyTestResult',
  //   ({ data: { latencyTimings } }) =>
  //     this.onLatencyTestResults(latencyTimings)
  // );
  // this.stream.addEventListener(
  //   'streamerListMessage',
  //   ({ data: { messageStreamerList, autoSelectedStreamerId } }) =>
  //     this.handleStreamerListMessage(messageStreamerList, autoSelectedStreamerId)
  // );
  // this.stream.addEventListener(
  //   'settingsChanged',
  //   (event) => this.configUI.onSettingsChanged(event)
  // );



}